export default class CurrencyService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('me/currencies', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/currencies/' + id, params)
	}

	getEntitiesForSelectBox(params) {
		return this.apiService.callGet('me/currencies/simple', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/CurrencyService.js